import { MarketingList } from 'features/ListBuilder/domain/MarketingList'
import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

type OpenPayload = {
  list: MarketingList
}

type ListSkipDataDownloadModalState = {
  state: {
    status: 'open'
    payload: OpenPayload
  } | {
    status: 'closed'
  }
  open: (payload: OpenPayload) => void
  close: () => void
}

const useListSkipDataDownloadModalStore = create<ListSkipDataDownloadModalState>()(immer(set => ({
  state: { status: 'closed' },
  open: payload => set(draft => {
    draft.state = { status: 'open', payload }
  }),
  close: () => set(draft => {
    draft.state = { status: 'closed' }
  }),
})))

export const useListSkipDataDownloadModal = () =>
  useListSkipDataDownloadModalStore(store => store.state)

export const useListSkipDataDownloadModalActions = () =>
  useListSkipDataDownloadModalStore(store => ({
    open: store.open,
    close: store.close,
  }))
